import React from "react";
import { cn } from "@/lib/utils";

export type SpinnerProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: "default" | "large";
  className?: string;
  appearance?: "black" | "white" | "purple" | "gray";
  testId?: string;
};

export const Spinner = ({
  size,
  className,
  appearance,
  testId = "spinner",
  ...props
}: SpinnerProps) => {
  return (
    <span
      className={cn(
        "tw-inline-block tw-rounded-circular tw-border-2 tw-border-r-transparent tw-border-l-base-white tw-border-t-base-white tw-border-b-base-white tw-size-[14.5px] tw-animate-spin",
        {
          "tw-size-[18.5px]": size === "large",
          "tw-border-l-gray-900 tw-border-t-gray-900 tw-border-b-gray-900":
            appearance === "black",
          "tw-border-l-purple-600 tw-border-t-purple-600 tw-border-b-purple-600":
            appearance === "purple",
          "tw-border-l-gray-300 tw-border-t-gray-300 tw-border-b-gray-300":
            appearance === "gray",
        },
        className,
      )}
      data-testid={testId}
      {...props}
    />
  );
};
